import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PageDesignerRoutingModule } from './page-designer-routing.module';
import { FormModalComponent } from './form-modal/form-modal/form-modal.component';
import { CustomSelectComponent } from './custom-select/custom-select.component';
import { CustomSliderComponent } from './custom-slider/custom-slider.component';
import { SupportingDocumentRuleConfigComponent } from './supporting-document-rule-config/supporting-document-rule-config.component';
import { FormioModule } from '@formio/angular';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


@NgModule({
  declarations: [
    FormModalComponent,
    CustomSelectComponent,
    CustomSliderComponent,
    SupportingDocumentRuleConfigComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PageDesignerRoutingModule,
    FormioModule,
    NgbModule
  ],
  schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA],
})
export class PageDesignerModule { }
